import { Slide } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useRef, useState } from "react";
import {
  MessageText,
  PromotionsContainer,
} from "../styles/promotiom";

const messages = [
  "כרגע המשלוחים הם בירושלים והסביבה בלבד - בקרוב בכל חלקי הארץ!",
  "שיינ'ס סטוק - עולם של יצירה",
  "שיינ'ס סטוק - הקנייה הזולה ביותר",
];

export default function Promotions() {
  const containerRef = useRef(null);

  const [show, setShow] = useState(true);
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    setShow(true);

    const visibleTime = messageIndex === 0 ? 5000 : 3000;

    const hideTimer = setTimeout(() => {
      setShow(false);
    }, visibleTime);

    const nextTimer = setTimeout(() => {
      setMessageIndex(
        (previousIndex) =>
          (previousIndex + 1) % messages.length
      );
    }, visibleTime + 1000);

    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [messageIndex]);

 return (
  <PromotionsContainer
    ref={containerRef}
    sx={{
      width: "100%",
      maxWidth: "1300px",
      mx: "auto",

      my: {
        xs: 0.5,
        md: 2,
      },

      borderRadius: 2,
      overflow: "hidden",

      // מבטל גובה קבוע שעלול להגיע מקובץ העיצוב
      minHeight: "unset",
      height: "auto",
    }}
  >
    <Box
      sx={{
        width: "100%",
        bgcolor: "#f2f5f7",
        boxSizing: "border-box",

        // המלבן קטן יותר בטלפון
        px: {
          xs: 1,
          sm: 2,
          md: 3,
        },
        py: {
          xs: 0,
          sm: 0.75,
          md: 1.25,
        },

        minHeight: "unset",
        height: "auto",

        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Slide
        direction={show ? "left" : "right"}
        in={show}
        container={containerRef.current}
        timeout={{
          enter: 500,
          exit: 200,
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <MessageText
            role="status"
            aria-live="polite"
            sx={{
              width: "100%",
              m: 0,
              color: "#D81B60",
              fontWeight: 500,
              textAlign: "center",
              direction: "rtl",

              // בטלפון קטן יותר, במחשב גדול כמו בתמונה
              fontSize: {
                xs: "1rem",
                sm: "1.3rem",
                md: "2rem",
              },

              lineHeight: {
                xs: 1.15,
                md: 1.4,
              },

              whiteSpace: {
                xs: "normal",
                md: "nowrap",
              },

              overflowWrap: "break-word",
            }}
          >
            {messages[messageIndex]}
          </MessageText>
        </Box>
      </Slide>
    </Box>
  </PromotionsContainer>
);
}